import { render } from "./Navigation.vue?vue&type=template&id=1abbeb2e"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=1abbeb2e&lang=less"
script.render = render

export default script